<template>
  <div class="pb-object-header">
    <PbIcon
      v-if="icon"
      :value="icon"
    />
    <div class="pb-object-header-text">
      <div
        v-if="breadcrumb.length"
        class="pb-object-header-breadcrumb txt-small"
      >
        <span
          v-for="(element, idx) in breadcrumb"
          :key="`${idx}-${element}`"
          :title="element"
          class="pb-object-header-breadcrumb-item-wrapper"
        >
          <span class="pb-object-header-breadcrumb-item">
            {{ element }}
          </span>
        </span>
      </div>
      <div
        class="pb-object-header-title"
        :title="title"
      >
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Color } from '@nicolaudie-group/ls-utilities'
import { useCurrent, useObject } from '@/composables/useProfile'
import PbIcon from '@/components/PbIcon/PbIcon.vue'

defineProps({
  icon: { type: [Array, String, Number, Color], default: '' },
})

const {
  mode,
  channel,
  presetRange,
  preset,
} = useCurrent()

const object = useObject()

const title = computed(() => {
  if (object.value) {
    return object.value.linkName
  }
  return ''
})

const breadcrumb = computed(() => {
  const result = []
  if (mode.value) {
    result.push(mode.value.linkName) // could also be defaultName, shortName, or baseName
  }
  if (channel.value) {
    result.push(channel.value.linkName)
  }
  if (presetRange.value) {
    result.push(presetRange.value.linkName)
  }
  if (preset.value) {
    result.push(preset.value.linkName)
  }
  result.pop()
  return result
})
</script>

<style lang="scss" src="./ObjectHeader.scss" />
